module.exports = __webpack_public_path__ + "static/img/97-3.a5f13ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/97-3.jpg
// module id = hoQN
// module chunks = 0